import React from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import { MonthPickerProps } from '@ecosystem/newron-design-system/build/components/datePicker/monthPicker/MonthPicker';
import { MonthPickerParams } from '../types';

const { MonthPicker, MonthFormatType } = inputs;

interface CustomMonthPickerProps {
  defaultStartDate: MonthPickerProps['defaultDate'];
  defaultEndDate: MonthPickerProps['defaultDate'];
  minDate: MonthPickerProps['minDate'];
  maxDate: MonthPickerProps['maxDate'];
  onChange: (type: 'from' | 'to', index: number) => (param: MonthPickerParams) => void;
  index: number;
}
export const CustomMonthPicker: React.FC<CustomMonthPickerProps> = ({
  defaultStartDate,
  defaultEndDate,
  minDate,
  maxDate,
  onChange,
  index,
}: CustomMonthPickerProps) => {
  const fromOnChangeFn = onChange('from', index);
  const toOnChangeFn = onChange('to', index);
  return (
    <>
      <div>
        <MonthPicker
          label={'Start date'}
          dateFormat={MonthFormatType['MMM yyyy']}
          defaultDate={defaultStartDate}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(value: Date, formatted: string) => fromOnChangeFn({ value, formatted })}
          name="start-date"
        />
      </div>
      <div>
        <MonthPicker
          label={'End date'}
          dateFormat={MonthFormatType['MMM yyyy']}
          defaultDate={defaultEndDate}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(value: Date, formatted: string) => toOnChangeFn({ value, formatted })}
          name="end-date"
        />
      </div>
    </>
  );
};
